import CurrencyCell from "../components/CurrencyCell";
import { daysInCurrentMonth } from "../helpers";

const currentMonthColDef = [
  {
    headerName: "",
    headerClass: "primary",
    children: [
      { field: "id", hide: true },

      {
        headerClass: "primary",
        headerName: "Warehouse",
        field: "Warehouse",
        width: 130,
        enableRowGroup: true,
        enablePivot: true,
        pinned: false,
        //editable: true,
        filter: "text",
        hide: true,
        //rowGroup: true,
      },
      {
        headerClass: "primary",
        headerName: "Channel",
        field: "OutletType",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        pinned: false,
        filter: "text",
        hide: true,
        //rowGroup: true,
        cellRenderer: "agGroupCellRenderer",
      },

      {
        headerClass: "primary",
        headerName: "Pricelist",
        field: "Pricelist",
        width: 175,
        enableRowGroup: true,
        enablePivot: true,
        pinned: false,
        //rowGroup: false,
        hide: true,
        filter: "text",
      },
      {
        headerClass: "primary",
        headerName: "ProductCode",
        field: "ProductCode",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        pinned: false,
        filter: "text",
        hide: true,
      },
      {
        headerClass: "primary",
        headerName: "Product",
        field: "Product_Name",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        pinned: true,
        rowGroup: true,
        filter: "agSetColumnFilter",
        filterParams: {
          keyCreator: (params) => {
            return params.data?.ProductCode || "";
          },
          valueFormatter: (params) => {
            return params.value || "(blank)";
          },
        },
        valueFormatter: (params) => {
          return params.value || "";
        },
      },
      {
        headerClass: "primary",
        field: "M2",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "M1",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "AOP",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "M",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "valueColumn",
      },
    ],
  },
];

var numberOfDaysInCurrentMonth = daysInCurrentMonth();

for (let day = 1; day <= numberOfDaysInCurrentMonth; day++) {
  currentMonthColDef[0].children.push({
    headerClass: "primary",
    field: String(day), // Dynamic field name
    width: 120,
    enablePivot: true,
    editable: false,
    aggFunc: "sum",
    cellRenderer: CurrencyCell,
    type: "rightAligned",
  });
}

export { currentMonthColDef };
